module.exports = "<div class=\"side-panel-interests\">\n  <div class=\"user-stats\">\n    <rzslider rz-slider-model=\"vm.userValue\" rz-slider-options=\"::vm.sliderOptions\"></rzslider>\n  </div>\n  <div class=\"job-stats\">\n    <rzslider rz-slider-model=\"vm.interestValue\" rz-slider-options=\"::vm.sliderOptions\"></rzslider>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/components/sidePanelInterests/sidePanelInterests.html
// module id = 84
// module chunks = 0 1